import type { RouteObject } from 'react-router'

import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'
import type { InjectedAppProps } from '../server/types/server.types.js'

export const createReportsRoutes = (
  injectedAppProps: InjectedAppProps,
): RouteObject => ({
  path: 'reports',
  async lazy() {
    const { ReportsBreadCrumb } = await import(
      '../client/components/Admin/Reports/ReportsRoute.js'
    )
    const { RouteContainer } = await import(
      '../client/components/Container/RouteContainer.js'
    )

    return {
      Component: RouteContainer,
      handle: routeCrumb(ReportsBreadCrumb),
    }
  },
  children: [
    {
      path: 'email-logs',
      async lazy() {
        const { EmailLogs, EmailLogsBreadCrumb } = await import(
          '../client/components/Admin/EmailLogs/index.js'
        )

        return {
          Component: EmailLogs,
          handle: routeCrumb(EmailLogsBreadCrumb),
        }
      },
    },
    {
      path: '*',
      async lazy() {
        const { Analytics, AnalyticsBreadCrumb } = await import(
          '../client/components/Analytics/Analytics.js'
        )

        return {
          element: (
            <Analytics
              networkId={injectedAppProps.network?.id}
              networkCreatedAt={injectedAppProps.network?.createdAt}
            />
          ),
          handle: routeCrumb(AnalyticsBreadCrumb),
        }
      },
    },
  ],
})
